import copy from "copy-to-clipboard";
import { message } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";

export const useCopy = () => {
  const { t } = useAppTranslation();

  const handleCopy = (string?: string | number) => {
    const copied = copy(String(string));
    if (copied) message.success({ content: t("common.copied") });
  };

  return { handleCopy };
};
